/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from 'react'
import { useLocation } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

// Importing Components
import Context from '../context/context'
import Card from './Card'
import Popup from './Popup'
import TabularContent from './TabularContent'
import kitchen from '../images/kitchen.svg'
import OrdersContent from './OrdersContent'
import NoSeatImage from "../images/NoSeatImage.png"
import { AccessTime, ExitToApp } from '@mui/icons-material'
import { openDB } from 'idb'
import { v4 as uuidv4 } from "uuid";

const Content = ({ setOrderProps }) => {

  const navigate = useNavigate();
  const page = window.location.pathname;
  const { pathname } = useLocation();
  const [searchState, setSearchState] = useState('');
  const [tutorial, setTutorial] = useState(false);
  const [scheduled, setSchedule] = useState(false);
  const [customerLinks, setCustomerLinks] = useState({});

  useEffect(() => {
    if (searchState === '') return
    document.querySelector('[type="search"]').focus()
  }, [searchState])

  // States
  const [selectedSeat, setSelectedSeat] = useState('');
  const [modalState, setModalState] = useState({ isVisible: false, data: null });

  const context = useContext(Context);
  const {
    selectedMenu,
    cartHandler,
    seatsState, setSeatsState, sectionsState, setSectionsState,
    setItemsState,
    forceRenderPage1, setMenusCollection,
    selectMenu, selected_category,
    itemChargesHandlerRef, itemChargesValueRef, cursorItemRef, runningOrders, setRunningOrders, showWarning
  } = context;

  const orderPropsHandler = ({ order_uuids, seat_uuid }) => {
    if (!page.includes('/page1')) return;
    setOrderProps({
      order_uuids,
      order_uuid: order_uuids?.[0],
      seat_uuid,
      order_type: '0',
      refreshDashboard: loadRunningOrders
    });
  }

  const highlightSeat = async (orders, seats) => {
    if (!page.includes('/page1')) return;
    const seat_uuid = seats?.[0] && sessionStorage.getItem('seat')?.length ? sessionStorage.getItem('seat') : '0';
    let order_uuids = orders?.[0] ? orders?.filter(i => i.seat_uuid === seat_uuid)?.map(i => i.order_uuid) : []
    if (!order_uuids?.[0]) order_uuids = [uuidv4()]

    orderPropsHandler({ order_uuids, seat_uuid })
    setSelectedSeat(seat_uuid);
  }

  const loadRunningOrders = async (seats = seatsState) => {
    const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const runningOrders = await db.transaction('running_orders', 'readonly').objectStore('running_orders').getAll();
    highlightSeat(runningOrders, seats)
    if (runningOrders?.length === 0) localStorage.setItem("onorder_seats", JSON.stringify([]));
    else
      runningOrders?.forEach(order => {
        if (order.invoice_prints && order.invoice_prints.length > 0 && order.order_status !== 4) {
          let onorder_seats = JSON.parse(localStorage.getItem("onorder_seats")) || [];
          let object = {
            seat_uuid: order.seat_uuid,
            created_at: order.created_at,
            price: order.order_total,
            title: order.local_order_id,
            uuid: order.order_uuid,
            invoiced: order?.invoice_prints?.length > 0 ? 1 : null
          };
          if (onorder_seats.length > 0) onorder_seats = onorder_seats.filter(obj => obj.seat_uuid !== order.seat_uuid);
          onorder_seats.push(object);
          localStorage.setItem("onorder_seats", JSON.stringify(onorder_seats));
        }
      })
    setRunningOrders(runningOrders)
  }

  useEffect(() => {
    let abortController = new AbortController();
    const storeData = async () => {

      if (page.includes('/page1')) sessionStorage.removeItem('current-nonseat-type')
      const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);

      const outletData = await (await db.transaction('outlet', 'readonly').objectStore('outlet').getAll())?.[0];
      await outletData.section_details.sort((a, b) => a.section_sort_order - b.section_sort_order);
      console.log('SETTING OUTLET SECTIONS IN STATE:', outletData?.section_details)
      setSectionsState(outletData.section_details);
      sessionStorage.setItem('kot_type', outletData.kot_type)
      sessionStorage.setItem('decimal_length', outletData.setup.decimal_length)

      const seats_collection = await db.transaction('seats', 'readonly').objectStore('seats').getAll();
      seats_collection.sort((a, b) => a.seat_sort_order - b.seat_sort_order);
      setSeatsState(seats_collection);

      const items = await db.transaction('item', 'readonly').objectStore('item').getAll();
      setItemsState(items);

      const customers = await db.transaction('customer', 'readonly').objectStore('customer').getAll();
      const detailsArray = [];
      customers.forEach(customer => detailsArray.push({
        customer_mobile: customer.customer_mobile,
        customer_name: customer.outlet_wise_customer_details?.[0]?.customer_name
      }))
      sessionStorage.setItem('customer_details', JSON.stringify(detailsArray));

      const menus_collection = await JSON.parse(sessionStorage.getItem("generated-collection"));
      if (menus_collection) setMenusCollection(menus_collection)

      loadRunningOrders()
    }
    storeData();
    return () => {
      abortController.abort()
    }
  }, [forceRenderPage1]);

  const handleSearch = (e) => {

    const page = window.location.pathname
    const searchInput = e.target.value.toLowerCase();

    if (page?.includes('/page2'))
      for (const i in selectedMenu?.category_and_items) {
        const category = selectedMenu?.category_and_items[i];
        const item_uuid = category?.menu_items?.filter(filterItem)?.[0]?.item_uuid
        if (item_uuid) {
          cursorItemRef.current = item_uuid
          break;
        }
      }

    setSearchState(e.target.value)

    if (searchInput.slice(0, 5) === 'wiki:' && searchInput.slice(searchInput.length - 1) === ';') {
      const param = searchInput.slice(5, searchInput.length - 1)
      window.open(`https://en.wikipedia.org/wiki/${param}`, '_blank')
    }

    if (!page.includes('/page1') || !seatsState) return;
    const filteredSeats = seatsState.map(seat => {
      if (seat.seat_name.toLowerCase().includes(searchInput))
        return { ...seat, seat_status: '1' }
      else
        return { ...seat, seat_status: '0' }
    });
    filteredSeats.sort((a, b) => +a.seat_sort_order - +b.seat_sort_order);
    setSeatsState(filteredSeats);
  }

  const modalViewHandler = ({ item_uuid, category_uuid }) => {
    cursorItemRef.current = item_uuid;
    document.querySelector(".highlighted-card")?.classList?.remove("highlighted-card");
    document.querySelector(`[item-uuid="${item_uuid}"] button`).classList.add("highlighted-card");
    setModalState({
      ...modalState, isVisible: !modalState.isVisible, data: selectedMenu?.category_and_items
        ?.find(s => s.category_uuid === category_uuid)?.menu_items
        ?.find(i => i.item_uuid === item_uuid)
    })
  };

  useEffect(() => {
    modalState.isVisible === true && sessionStorage.setItem('popup-state', true);
    modalState.isVisible === false && sessionStorage.setItem('popup-state', false);
  }, [modalState])

  const [searchInFocus, setSearchInFocus] = useState(true);
  function menuOpenHandler(item) {

    if (!item?.menu_details?.[0]) return showWarning({
      message: 'Please Apply Menu to the Seat',
      classname: 'active-red'
    });

    sessionStorage.setItem('seat-menu-details', JSON.stringify(item?.menu_details))
    selectMenu(item?.menu_details?.[0], '0', () => {
      itemChargesValueRef.current = [];
      itemChargesHandlerRef.current.click()

      let order_uuids = item.order_uuid
      if (!order_uuids?.[0]) order_uuids = [uuidv4()]

      orderPropsHandler({ order_uuids, seat_uuid: item?.seat_uuid });
      navigate(`/page2/0/${order_uuids?.[0]}`);
    });
  }

  var seatIndex = -1;
  var itemsIndex = -1;
  let sectionIndex = -1;
  let categoryIndex = -1;

  const [visibleContext, setVisibleContext] = useState({ id: "", elemProperties: "" });

  const seatClickHandler = async (buttonChild, seat, clickCount) => {

    if (seat !== selectedSeat && (clickCount === 1 || clickCount === 0)) {
      document.querySelector(".highlighted-card")?.classList?.remove("highlighted-card");
      buttonChild?.classList?.add("highlighted-card");
      sessionStorage.setItem('seat', seat);
      let order_uuids = runningOrders?.filter(i => i.seat_uuid === seat)?.map(i => i.order_uuid)
      if (!order_uuids?.[0]) order_uuids = [uuidv4()]
      setSelectedSeat(seat);
      orderPropsHandler({ order_uuids, seat_uuid: seat });
      setVisibleContext({})
    }
    let reg_website = await +sessionStorage.getItem("reg-website")
    if (reg_website && reg_website < 3) {
      setTutorial(true);
      setTimeout(() => setTutorial(false), 3000);
      sessionStorage.setItem("reg-website", parseInt(reg_website) + 1);
    }
  }

  useEffect(() => {
    const getDataFromIndexdDb = async () => {
      const db = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
      const indSections = await db.transaction("outlet", "readonly").objectStore("outlet");
      const currentSections = (await indSections.getAll())[0];
      setCustomerLinks(currentSections?.customer_link_services?.find(a => a.service_name === "Schedule"))
    };
    getDataFromIndexdDb();
  }, []);

  const filterItem = item => {
    const match = str => str?.toLowerCase()?.includes(searchState?.toLowerCase())
    if (searchState?.length > 0)
      return match(item.item_code) || match(item.item_name)
    else return true
  }

  useEffect(() => {
    let item_uuid;
    if (selected_category === 'All')
      item_uuid = selectedMenu?.category_and_items?.[0]?.menu_items?.[0]?.item_uuid
    else item_uuid = selectedMenu?.category_and_items
      ?.find(i => i.category_name === selected_category)
      ?.menu_items?.[0]?.item_uuid

    document.querySelector(`[item-uuid="${item_uuid}"]`)?.querySelector('button.card-focus').classList.add('highlighted-card')
    cursorItemRef.current = item_uuid
  }, [selected_category])

  useEffect(() => {
    let item_uuid = selectedMenu?.category_and_items?.[0]?.menu_items?.[0]?.item_uuid;
    document.querySelector(`[item-uuid="${item_uuid}"]`)?.querySelector('button.card-focus').classList.add('highlighted-card')
    cursorItemRef.current = item_uuid
  }, [selectedMenu])

  const filterCategory = category => {
    if (!selected_category || selected_category === 'All') return true
    else return category?.category_name === selected_category
  }

  return (
    <div className="content-container" id="content-file-container">
      {
        pathname === "/page3" ? (<TabularContent />)
          : pathname.includes("/page1") ? (
            <>
              {seatsState?.[0] ?
                <>
                  {sectionsState?.[0] && sectionsState?.map((section) => {

                    let sectionVisible;
                    let seatsCollection = seatsState?.filter(seat => seat.section_uuid === section.section_uuid && seat.outlet_uuid === localStorage.getItem('outlet_uuid'));

                    const isVisible = (seat) => seat.seat_status === "1";
                    sectionVisible = seatsCollection && seatsCollection.some(isVisible);

                    if (sectionVisible === false) return "";
                    else {
                      sectionIndex++;
                      return (
                        <div key={Math.random()} className="sectionDiv">
                          <h1>{section?.section_name}</h1>
                          <div
                            className="content"
                            id="seats_container"
                            this-section-index={sectionIndex}
                          >
                            {seatsCollection && seatsCollection.map((item) => {

                              const orders = runningOrders?.filter(i => i.seat_uuid === item.seat_uuid);
                              item.color = orders?.[0] ? (orders?.[0]?.invoice_prints?.[0] ? "yellow" : "red") : "#4AC959";
                              item.price = orders?.reduce((sum, i) => sum + +i.order_total, 0) || 0;
                              item.title1 = orders?.map(i => i.local_order_id)?.join(', ');
                              item.order_uuid = orders?.map(i => i.order_uuid)
                              item.title2 = item.seat_name
                              item.created_at = orders?.[0]?.created_at

                              let unplaced_orders = JSON.parse(localStorage.getItem("unplaced_orders"));
                              let unplaced_order = unplaced_orders?.find(order => order.seat === item.seat_uuid && order?.items?.length > 0) || null;
                              item.color = unplaced_order ? "blue" : item.color;
                              if (unplaced_order?.order_uuid) item.order_uuid = [unplaced_order?.order_uuid]

                              if (+item.seat_status === 0) return "";
                              else {
                                return (
                                  <div
                                    index={++seatIndex}
                                    section-index={sectionIndex}
                                    className={`seatSearchTarget`}
                                    key={Math.random()}
                                    seat-name={item.seat_name}
                                    seat-code={item.seat_uuid}
                                    seat={item.seat_uuid}
                                    section={section.section_uuid}
                                    section-name={section?.section_name}
                                    outlet={localStorage.getItem('outlet_uuid')}
                                    onClick={e => {
                                      seatClickHandler(
                                        e.currentTarget.querySelector('.card-focus'), item?.seat_uuid, e.detail
                                      );
                                    }}
                                    onMouseDown={e => {
                                      e.preventDefault();
                                      if (e.detail > 1) menuOpenHandler(item)
                                      else seatClickHandler(
                                        e.currentTarget.querySelector('.card-focus'), item?.seat_uuid, e.detail
                                      );
                                    }}
                                  >
                                    <span
                                      className="dblClickTrigger"
                                      style={{ display: "none" }}
                                      onClick={() => menuOpenHandler(item)}
                                    />
                                    <Card
                                      key={item?.seat_uuid}
                                      item={item}
                                      visibleContext={visibleContext}
                                      setVisibleContext={setVisibleContext}
                                      seats={seatsState?.filter(s => +s.seat_status === 1)}
                                      selected_seat={selectedSeat === '0' && seatIndex === 0 ? item?.seat_uuid : selectedSeat}
                                      rounded
                                    />
                                  </div>
                                );
                              }
                            })}
                          </div>
                        </div>
                      );
                    }
                  })}
                  <div className="searchBar" style={{ width: "400px" }}>
                    <input
                      type="search"
                      placeholder="Search..."
                      value={searchState}
                      onClick={() => setSearchInFocus(true)}
                      onBlur={() => setSearchInFocus(false)}
                      onChange={(e) => handleSearch(e)}
                      onKeyDown={(e) => {
                        if (e.key === "+" || e.key === "-" || e.shiftKey || e.ctrlKey)
                          e.preventDefault();
                        if (e.key === "Backspace") {
                          e.target.value = "";
                          handleSearch(e);
                        }
                      }}
                      autoFocus={searchInFocus}
                    />
                  </div>
                </>
                : <div style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  height: "100%"
                }}> <img src={NoSeatImage} alt="NO Seats" /> </div>}
            </>
          ) : pathname.includes("/page2") ? (
            <>
              {selectedMenu?.category_and_items?.filter(filterCategory)?.filter(i => i.menu_items?.some(filterItem))?.map((menu, i) => {

                categoryIndex++;

                return (
                  <div key={Math.random()} className="categoryDiv">
                    <h1>{menu.category_name}</h1>
                    <div className="content" this-section-index={categoryIndex}>
                      {menu.menu_items?.filter(filterItem)?.map((item) => {

                        const isAddon = item.menu_item_addons && item.menu_item_addons.length > 0 ? true : false;
                        const isMulti = item.menu_item_multi && item.menu_item_multi.length > 0 ? true : false;

                        return (
                          <div
                            section-index={categoryIndex}
                            key={Math.random()}
                            index={++itemsIndex}
                            style={{ width: "max-content" }}
                            className={`itemDiv`}
                            item-name={item.item_name}
                            item-code={item.item_code}
                            item-uuid={item.item_uuid}
                            onClick={(e) => {
                              cursorItemRef.current = item.item_uuid;
                              document.querySelector(".highlighted-card")?.classList?.remove("highlighted-card");
                              e.currentTarget.querySelector("button").classList.add("highlighted-card");
                            }}
                          >
                            <Card
                              key={Math.random()}
                              item={item}
                              onclickFunction={isAddon || isMulti ? modalViewHandler : cartHandler}
                              cursorItemRef={cursorItemRef}
                              index={itemsIndex}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
              {modalState.isVisible && (
                <Popup modalState={modalState} setModalState={setModalState} />
              )}
              <div className="searchBar" style={{
                width: "400px"
              }}>
                <input
                  type="search"
                  placeholder="Search..."
                  value={searchState}
                  onClick={() => setSearchInFocus(true)}
                  onBlur={() => setSearchInFocus(false)}
                  onChange={(e) => handleSearch(e)}
                  onKeyDown={(e) => {
                    if (e.key === "+" || e.key === "-" || e.shiftKey || e.ctrlKey)
                      e.preventDefault();
                    if (e.key === "Backspace") {
                      e.target.value = "";
                      handleSearch(e);
                    }
                  }}
                  autoFocus={searchInFocus}
                />
              </div>
            </>
          ) : pathname.includes("/orders") ? (
            <>
              <OrdersContent
                setOrderProps={setOrderProps}
                scheduled={scheduled}
                scheduleOrders={JSON.parse(localStorage.getItem("meal_orders"))}
              />
              <div className="searchBar" style={{ width: "400px" }}>
                <input
                  type="search"
                  placeholder="Search..."
                  value={searchState}
                  onClick={() => setSearchInFocus(true)}
                  onBlur={() => setSearchInFocus(false)}
                  onChange={(e) => handleSearch(e)}
                  onKeyDown={(e) => {
                    if (e.key === "+" || e.key === "-" || e.shiftKey || e.ctrlKey)
                      e.preventDefault();
                    if (e.key === "Backspace") {
                      e.target.value = "";
                      handleSearch(e);
                    }
                  }}
                  autoFocus={searchInFocus}
                />
              </div>
            </>
          ) : (
            ""
          )}
      <div id="kitchen-ico" onClick={() => navigate("/kds")}>
        <img src={kitchen} alt="kitchen" />
      </div>
      {scheduled ? <div id="kitchen-ico" style={{ marginRight: "60px" }}>
        <ExitToApp alt="kitchen" onClick={() => setSchedule(false)} />
      </div>
        : customerLinks.service_status === "Y" && window.location.pathname.includes("orders") ? <div id="kitchen-ico" style={{ marginRight: "60px" }}>
          <AccessTime alt="kitchen" onClick={() => setSchedule(true)} />
        </div> : ""}
      <div className={`copies_notification 
      ${tutorial ? "copies_notification_active" : ""}`}
        style={{ zIndex: "999999" }}
      >
        Double Click on Seat !!
      </div>
    </div>
  );
}

export default Content